import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/mui";
import { Alert, Button, Stack, Typography } from "@mui/material";
import { blockUserApi } from "functions/axios";

import {
    DetailSection,
    FieldGrid,
    FieldItem,
    RelatedLink,
    joinParts,
} from "components/detail";

export const TeacherShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading, isError } = queryResult;

    const record = data?.data;

    return (
        <Show
            isLoading={isLoading}
            title={
                <Typography variant="h5">
                    교사 상세{record?.id ? ` · ${record.id}` : ""}
                </Typography>
            }
            headerButtons={({ defaultButtons }) => (
                <>
                    {defaultButtons}
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                            blockUserApi(record?.id, { status: "WITHDRAWN" });
                        }}
                    >
                        탈퇴
                    </Button>
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={() => {
                            blockUserApi(record?.id, { status: "RESTRICTED_SEVEN_DAYS" });
                        }}
                    >
                        7일 정지
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                            blockUserApi(record?.id, { status: "BAN" });
                        }}
                    >
                        영구정지
                    </Button>
                </>
            )}
        >
            {isError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    교사를 불러오지 못했습니다.
                </Alert>
            )}

            <Stack spacing={2}>
                <DetailSection title="기본 정보">
                    <FieldGrid columns={2}>
                        <FieldItem label="로그인 Id" value={record?.loginId} />
                        <FieldItem label="이름" value={record?.name} />
                        <FieldItem label="별명(닉네임)" value={record?.nickName} />
                        <FieldItem label="권한" value={record?.auth} />
                        <FieldItem
                            label="주소"
                            value={joinParts([record?.address, record?.detailAddress], "  ")}
                        />
                        <FieldItem label="전화번호" value={record?.phoneNumber} />
                        <FieldItem label="이메일주소" value={record?.emailAddress} />
                        <FieldItem
                            label="알림 확인 여부"
                            value={record?.readAlarm === true ? "예" : "아니오"}
                        />
                        <FieldItem
                            label="승인 상태"
                            value={
                                record?.approval === "ACCEPT"
                                    ? "완료"
                                    : record?.approval === "WAITING"
                                    ? "대기중"
                                    : "거절"
                            }
                        />
                        <FieldItem
                            label="첨부이미지"
                            value={
                                <RelatedLink
                                    to={`/images?filters[0][field]=targetId&filters[0][operator]=eq&filters[0][value]=${record?.id}&filters[1][field]=category&filters[1][operator]=eq&filters[1][value]=USER`}
                                    label="바로가기"
                                />
                            }
                        />
                        <FieldItem label="생성일" value={record?.createdDate} />
                        <FieldItem label="수정일" value={record?.updatedDate} />
                    </FieldGrid>
                </DetailSection>
            </Stack>
        </Show>
    );
};
